'use client';
import { useEffect, useRef } from 'react';

import { useGridFilters } from '~features/gridFilters/hooks/useGridFilters';
import {
	loadFromSessionStorage,
	saveToSessionStorage,
	ssKeys,
} from '~features/storage';
import { useSession } from '~hooks/useSession';

export const GridFiltersAnnals = ({ slug }: { slug?: string }) => {
	const { isSuccess } = useSession();
	const { filters, sendFiltersDataToAnnals } = useGridFilters();
	const hasTrackedOnce = useRef(false);

	useEffect(() => {
		if (isSuccess && !hasTrackedOnce.current) {
			hasTrackedOnce.current = true;

			const wasManualUpdate = loadFromSessionStorage(
				ssKeys.GRID_FILTERS_MANUAL_UPDATE,
				false
			);

			if (wasManualUpdate) {
				saveToSessionStorage(ssKeys.GRID_FILTERS_MANUAL_UPDATE, false);
				return;
			}

			sendFiltersDataToAnnals(filters, false, slug);
		}
	}, [filters, isSuccess, sendFiltersDataToAnnals, slug]);

	return null;
};
